import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import TextInput from "components/forms/inputs/text";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { faSave } from "components/icon-library";
import { OrganizationModel } from "models/organization";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { adminDoPatchOrganization } from "services/admin/organization";
import { fetchOrganization } from "stores/actions/organization";
import * as yup from "yup";

interface BaseFormProps {
  organization: OrganizationModel;
}

const BaseForm: FunctionComponent<BaseFormProps> = ({ organization }) => {
  const schema = yup
    .object({ name: yup.object().validateLocaleString() })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: organization.name,
    },
  });

  const handleSubmit = async (values: any) => {
    // save
    await adminDoPatchOrganization(values.name);

    // fetch and update state
    fetchOrganization();
  };

  const buttons: FormButtonInterface[] = [
    { ...SubmitButton, align: "left", postIcon: faSave },
  ];

  return (
    <Form methods={methods} onSubmit={handleSubmit}>
      <Grid>
        <Row>
          <Col>
            <TextInput name="name" label="Organisaation nimi" translations />
          </Col>
          <Col></Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default BaseForm;
